import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { useStores } from '../../hooks/use-stores';

import OrdersTable from './OrdersTable';
import OrderCard from './OrderCard';
import { useMediaQuery, useTheme } from '@material-ui/core';

const ShortOrderList = observer(() => {
    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));
    const { ProfileOrderStore: store } = useStores();
    const { loaderOrders, getShortOrdersList, orders } = store || {};

    useEffect(() => {
        getShortOrdersList();
    }, [getShortOrdersList]);

    return <> {isSM ? <OrderCard load={loaderOrders} data={orders} /> : <OrdersTable load={loaderOrders} data={orders} />}</>;
});

export default ShortOrderList;
